import { render, staticRenderFns } from "./applicationbar-toggle-button.vue?vue&type=template&id=4e60d51b&scoped=true"
import script from "./applicationbar-toggle-button.vue?vue&type=script&lang=ts"
export * from "./applicationbar-toggle-button.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e60d51b",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBadge,VBtn,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e60d51b')) {
      api.createRecord('4e60d51b', component.options)
    } else {
      api.reload('4e60d51b', component.options)
    }
    module.hot.accept("./applicationbar-toggle-button.vue?vue&type=template&id=4e60d51b&scoped=true", function () {
      api.rerender('4e60d51b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/layout/applicationbar-toggle-button.vue"
export default component.exports